import { Drawer as MantineDrawer } from "@mantine/core";
import { faXmarkLarge } from "@fortawesome/pro-solid-svg-icons";
import type { CustomDrawerCloseButtonFactory, IProps } from "./drawer-close-button.types";
import { componentWrapper } from "../../../utilities";
import { ActionIcon } from "../../action-icon";
import { Icon } from "../../icon";

const DrawerCloseButton = componentWrapper<CustomDrawerCloseButtonFactory, IProps>(
    "DrawerCloseButton",
    (props, ref) => {
        return (
            <MantineDrawer.CloseButton
                ref={ref}
                size="lg"
                icon={
                    <ActionIcon variant="subtle" size="input-xs" color="gray">
                        <Icon size="sm" icon={faXmarkLarge} />
                    </ActionIcon>
                }
                {...props}
            />
        );
    }
);

export { DrawerCloseButton };
